import { motion } from "framer-motion";
import { Check, Copy, Mail, MessageCircle } from "lucide-react";
import { toast } from "sonner";
import { formatOrderText, mailLink, smsLink } from "@/lib/order";
import { SHOP } from "@/data/menu";

export const OrderSuccess = ({ order }) => {
  const text = formatOrderText(order);
  const copy = async () => {
    try {
      await navigator.clipboard.writeText(text);
      toast.success("Order copied");
    } catch {
      toast.error("Couldn't copy. Please select the text below.");
    }
  };

  return (
    <div data-testid="order-success">
      <motion.div
        initial={{ scale: 0, rotate: -40 }}
        animate={{ scale: 1, rotate: 0 }}
        transition={{ type: "spring", stiffness: 260, damping: 16 }}
        className="grid h-16 w-16 place-items-center rounded-full bg-[#E11D48] text-white"
      >
        <Check className="h-8 w-8" />
      </motion.div>
      <p className="f-mono mt-6 text-xs uppercase tracking-[0.2em] text-rose" data-testid="order-number">Order {order.order_number}</p>
      <h3 className="f-display mt-2 text-4xl font-semibold leading-tight text-cacao">One last step — send it to us!</h3>
      <p className="mt-3 text-sm text-cacao-2">
        Tap a button below to send your order by text to {SHOP.phoneDisplay} or by email. We'll reply with your quote.
      </p>
      <div className="mt-7 grid gap-3">
        <a
          href={smsLink(text)}
          data-testid="send-sms-button"
          className="flex items-center justify-center gap-2 rounded-full bg-[#2D1E18] py-4 text-sm font-semibold text-white transition-colors hover:bg-[#E11D48]"
        >
          <MessageCircle className="h-4 w-4" /> Send by Text
        </a>
        <a
          href={mailLink(order, text)}
          data-testid="send-email-button"
          className="flex items-center justify-center gap-2 rounded-full border border-[#2D1E18] py-4 text-sm font-semibold text-cacao transition-colors hover:bg-[#2D1E18] hover:text-white"
        >
          <Mail className="h-4 w-4" /> Send by Email
        </a>
        <button onClick={copy} data-testid="copy-order-button" className="flex items-center justify-center gap-2 py-2 text-sm font-medium text-cacao-2 hover:text-cacao">
          <Copy className="h-4 w-4" /> Copy order text
        </button>
      </div>
      <pre className="mt-6 whitespace-pre-wrap rounded-2xl border border-[#F0DDD3] bg-white p-5 text-xs leading-relaxed text-cacao" data-testid="order-text-preview">
        {text}
      </pre>
    </div>
  );
};
